var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseIconBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.493.287 4.957 3.822 1.422.287.244 1.465 3.78 5 .244 8.535l1.178 1.178 3.535-3.535 3.536 3.535 1.179-1.178L6.137 5l3.535-3.535L8.493.287Z",
  fill: "#2C2E3F"
})));
export { SvgCloseIconBlack as ReactComponent };
export default __webpack_public_path__ + "6b33bf15f4afa29a768edce1d2f2a369.svg";